import authStore from "@/stores/authStore";
import { Box } from "@mui/material";
import "./header.css";
import BasePhoto from "@/assets/icons/basePhoto.svg";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../breadcrumb/breadcrumb";
import { useEffect, useState } from "react";
import NotificationMessagesDialog from "../messages/notificationMessagesDialog";

const Header = () => {
    const { t } = useTranslation();
    const [openNotificationMessagesDialog, setOpenNotificationMessagesDialog] = useState(false);

    const handleCloseDialog = () => {
        setOpenNotificationMessagesDialog(false);
    };
    const [arentReadMessagesCount, setArentReadMessagesCount] = useState(0);

    const handleShowPhoto = (imagePath: string) => {
        if (imagePath == null || imagePath === "") {
            return BasePhoto;
        }
        return imagePath;
    };

    useEffect(() => {
        setArentReadMessagesCount(authStore.unreadMessagesCount);
    }, [authStore.unreadMessagesCount]);
    return (
        <>
            <NotificationMessagesDialog
                open={openNotificationMessagesDialog}
                handleClose={handleCloseDialog}
            ></NotificationMessagesDialog>
            <Box className="header-container">
                <Box className="header-left-element font-style">
                    <i
                        onClick={() => setOpenNotificationMessagesDialog(true)}
                        style={{ marginInlineEnd: "25px" }}
                        className="icon-f icon-bell fs-26 cursor-pointer p-relative"
                    >
                        {arentReadMessagesCount ? (
                            <span className="message-counter">{arentReadMessagesCount}</span>
                        ) : (
                            ""
                        )}
                    </i>
                    <Breadcrumb />
                </Box>
                <Box className="header-right-element">
                    <div className="org-logo-frame">
                        {authStore.organizationLogoUrl != null && authStore.organizationLogoUrl !== "" ? (
                            <img src={authStore.organizationLogoUrl} alt="CompanyLogo" />
                        ) : (
                            <div className="font-style">Update logo</div>
                        )}
                    </div>
                    <div className="vertical-divider"></div>
                    <div className="user-info font-style">
                        <div>
                            <div className="t-end">
                                {t("header.HelloMsg")}&nbsp;
                                <span className="username">{authStore.displayName}</span>
                            </div>
                            <div className="user-photo-active">
                                {authStore.phoneNumber}
                                <div className="user-status-color-active"></div>{" "}
                                {authStore.isActive ? t("employee.ActiveStatus") : t("employee.InactiveStatus")}
                            </div>
                        </div>
                        <div className="photo-frame border-gradient-gray">
                            <img src={handleShowPhoto(authStore.imagePath)} alt="UserPhoto"></img>
                        </div>
                    </div>
                </Box>
            </Box>
        </>
    );
};

export default Header;
